import { createContext, useContext } from 'react';
import { IUserDetails } from 'src/interfaces/user';

const useUserController = (userDetails?: IUserDetails) => {
  return {
    ...(userDetails && {
      user: { ...userDetails },
    }),
  };
};

const UserContext = createContext<ReturnType<typeof useUserController>>({});

export const UserProvider = ({ userDetails, children }) => (
  <UserContext.Provider value={useUserController(userDetails)}>
    {children}
  </UserContext.Provider>
);

export const useUserContext = () => useContext(UserContext);
